import {
  createRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

export const academyRouteRef = createRouteRef({
  id: 'academy',
});

export const contributorExternalRouteRef = createExternalRouteRef({
  id: 'academy:contributor',
  optional: true,
});
